import DetailView from "../custom/DetailView";
import {
    RoleIdEnum,
    useGetReceivedPaymentQuery,
    useRemoveReceivedPaymentMutation,
    useUpdateReceivedPaymentMutation
} from "../../generated/graphql";
import {useParams} from "react-router";
import DefaultQueryHandler from "../../common/DefaultQueryHandler";
import {AppBar, Grid, Tab, Tabs} from "@material-ui/core";
import {InvoiceStatusList, InvoiceStatusMap, ReceivedPaymentStatusMap} from "../../common/Constant";
import React, {useCallback} from "react";
import {format} from "date-fns";
import {DataGridLocale} from "../../common/DataGridLocale";
import {dateValueFormatter, HasRole, PasteToClipboard, useTabIndex, ViewColumn} from "../../common/Util";
import {DataGridPro, GridColDef} from "@mui/x-data-grid-pro";
import NotificationPopup from "../../common/NotificationPopup";
import Page from "../../components/Page";
import TabPanel from "../custom/TabPanel";
import LinkInvoicesButton from "./LinkInvoicesButton";
import ConfirmButton from "../../components/ConfirmButton";
import {useNavigate} from "react-router-dom";
import {InputType} from "../../common/FormRenderer";
import CreateView from "../custom/CreateView";


const invoiceColumns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 120, type: "number" },
    { field: "status", headerName: "狀態", width: 200,
        valueFormatter: ({value}) => InvoiceStatusMap[value as string],
        valueOptions: InvoiceStatusList,
        type: "singleSelect" },
    { field: "invoiceNumber", headerName: "發票號碼", width: 200 },
    { field: "postDate", headerName: "開立發票日期", width: 150, valueFormatter: dateValueFormatter, type: "date" },
    ViewColumn('/app/invoice'),
];
const columns = [
    {field: "id", headerName: "ID"},
    {
        field: "status",
        headerName: "狀態",
        valueFormatter: (value) => {
            return ReceivedPaymentStatusMap[value];
        },
    },
    {
        field: "date",
        headerName: "收款日期",
        valueFormatter: (value) => format(new Date(value), "yyyy-MM-dd"),
    },
    {
        field: "amount",
        headerName: "金額",
        valueFormatter: (value) => {
            return value?.toLocaleString();
        },
    },
    {
        field: "customer", headerName: "客戶", valueFormatter: (value) => {
            return value?.name
        }
    },
    {field: "remark", headerName: "匯款備註"},
    {field: "sourceBankCode", headerName: "匯款銀行代碼"},
    {field: "sourceBankAccountNumber", headerName: "匯款帳號"},
    {field: "destinationBankAccountNumber", headerName: "虛擬帳號"},
    // {field: "note", headerName: "財務註記"},
];
export default () => {
    const navigate = useNavigate();
    const {id} = useParams();
    const {loading, data, error} = useGetReceivedPaymentQuery({variables: {id}});
    const [tabIndex, setTabIndex] = useTabIndex();
    const [removeReceivedPayment] = useRemoveReceivedPaymentMutation();
    const [updateReceivedPayment] = useUpdateReceivedPaymentMutation();
    const onRemove = useCallback(async ()=>{
        try {
            await removeReceivedPayment({
                variables: {id},
                refetchQueries: ["getReceivedPaymentList"]
            })
            NotificationPopup.success(`刪除成功`);
            navigate("/app/receivedPayment")
        }
        catch (e) {
            NotificationPopup.error(`發生問題: ${e.message}`);
        }

    }, [removeReceivedPayment]);
    const onUpdate = useCallback(async (updatedReceivedPayment, { resetForm }, setOpen)=>{
        try {
            console.log(updatedReceivedPayment);
            await updateReceivedPayment({
                variables: {id, receivedPayment: updatedReceivedPayment},
                refetchQueries: ["getReceivedPayment"]
            });
            NotificationPopup.success(`更新成功`);
            setOpen(false);
        }
        catch (e) {
            NotificationPopup.error(`發生問題: ${e.message}`);
        }
    }, [updateReceivedPayment]);
    return (
        <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Finance]}>
        <Page title={"receive payment detail page"}>
            <AppBar position="static" color="default">
                <Tabs
                    value={tabIndex}
                    indicatorColor="secondary"
                    textColor="secondary"
                    onChange={(
                        event: React.ChangeEvent<{}>,
                        newValue: number
                    ) => {
                        setTabIndex(newValue);
                    }}
                >
                    <Tab label="收款單"/>
                    <Tab label="連結發票"/>
                </Tabs>
            </AppBar>

            <DefaultQueryHandler error={error} loading={loading}>
                <TabPanel value={tabIndex} index={0}>
                    <Grid container spacing={2}>
                        <Grid item>
                            <CreateView
                                title={"修改"}
                                columns={[
                                    {
                                        name: "remark",
                                        label: "匯款備註",
                                        type: InputType.textarea,
                                        value: data?.receivedPayment?.remark,
                                    },
                                ]}
                                onSubmit={onUpdate}
                                submitTitle={"修改"}
                                queryEntity={"receivedPayment"}
                            />
                        </Grid>
                        <Grid item>
                            <ConfirmButton onConfirm={()=>{
                                onRemove();
                            }}>刪除</ConfirmButton>
                        </Grid>
                    </Grid>
                    <DetailView columns={columns} data={data?.receivedPayment}/>
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                    <LinkInvoicesButton receivedPayment={data?.receivedPayment}/>
                    <br/>
                    <DataGridPro
                        columns={invoiceColumns}
                        sortModel={[{field:"id",sort:"desc"}]}
                        rows={data?.receivedPayment.invoices!}
                        hideFooter={true}
                        autoHeight={true}
                        localeText={DataGridLocale}
                        onCellClick={PasteToClipboard}
                    />
                </TabPanel>
            </DefaultQueryHandler>
        </Page>
        </HasRole>
    );
};
